import Vue from 'vue';
import Vuex from 'vuex';

import { CollectionStoreDefinition } from './collection.store';
import { AuthStoreDefinition } from './auth.store';
import { NotificationStoreDefinition } from './notification.store';
import { SearchStoreDefinition } from './search.store';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    collection: CollectionStoreDefinition,
    auth: AuthStoreDefinition,
    notification: NotificationStoreDefinition,
    search: SearchStoreDefinition,
  }
});

export default store;
